export default "__VITE_ASSET__By_n8qmm__"